import { Component, Input } from '@angular/core';
import { SlotsController } from '@shared/src/controllers/address/slots/slots.controller';
import { PhaseController } from '@shared/src/controllers/route/phase/phase.controller';
import { SlotInfoDto } from '@shared/src/dtos/address/slots/SlotInfoDto';
import { RouteGroupShipmentDto } from '@shared/src/dtos/route/RouteGroupShipmentDto';
import { HColor, HomeController, RouteCardDto, ShipmentController } from '@shared/src/public-api';

@Component({
  selector: 'shared-trucking-route-strip-card-component',
  templateUrl: './shared.trucking.route.strip.component.html',
  styleUrls: ['./shared.trucking.route.strip.component.scss'],
})
export class SharedTruckingRouteStripComponent {

  public useIonic: boolean = false;

  constructor(protected homeController: HomeController, protected slotsController: SlotsController, protected phaseController: PhaseController, protected shipmentController: ShipmentController) {

  }


  public showAssignedSlots: boolean = false;

  private _route: RouteCardDto;
  @Input()
  set route(value: RouteCardDto) {
    if (this._route === value)
      return;
    this._route = value;
    this.obtainValues();
  }
  get route(): RouteCardDto {
    return this._route;
  }
  private obtainValues() {
  }


  OnInit() {
  }

  public pretty(value) {
    return JSON.stringify(value);
  }
}
